export const FEATURE_NAMES = {
  SAT: 'sat',
  PHISHING: 'phishing',
  MANAGE_DEVICES: 'manage-devices',
  MANAGE_USERS: 'manage-users',
  RELEASE_NOTES: 'release-notes',
  DOWNLOAD_APPLET: 'download-applet',
  MANAGE_ACCOUNTS: 'manage-accounts',
  FAILING_FACTORS_REPORT: 'failing-factors-report',
  ANALYTICS: 'analytics',
  PASSWORD_POLICY: 'password-policy',
  CYBER_SECURITY_POLICY: 'cyber-security-policy',
  DRIVE_LEAKAGE: 'drive-leakage',
  PLUGINS: 'plugins',
  RAD: 'rad',
  MY_REPORTS: 'my-reports',
  SUPPORT: 'support',
  DEVICE_SYSTEM_LOGS: 'device-system-logs',
  COMPLIANCE: 'compliance',
  LPL_SUPPORT: 'lpl-support',
  RESTRICTED_APPLICATIONS_AND_PROCESSES: 'restricted-applications-and-processes'
} as const;

export const API_ACCESS_TYPES = ['read', 'create', 'update', 'delete'] as const;

export const FEATURE_ACCESS_MAP = Object.freeze({
  SAT_READ: 'sat:read',
  SAT_CREATE: 'sat:create',
  SAT_UPDATE: 'sat:update',
  SAT_DELETE: 'sat:delete',

  PHISHING_READ: 'phishing:read',
  PHISHING_CREATE: 'phishing:create',
  PHISHING_UPDATE: 'phishing:update',
  PHISHING_DELETE: 'phishing:delete',

  MANAGE_DEVICES_READ: 'manage-devices:read',
  MANAGE_DEVICES_CREATE: 'manage-devices:create',
  MANAGE_DEVICES_UPDATE: 'manage-devices:update',
  MANAGE_DEVICES_DELETE: 'manage-devices:delete',

  MANAGE_USERS_READ: 'manage-users:read',
  MANAGE_USERS_CREATE: 'manage-users:create',
  MANAGE_USERS_UPDATE: 'manage-users:update',
  MANAGE_USERS_DELETE: 'manage-users:delete',

  RELEASE_NOTES_READ: 'release-notes:read',
  RELEASE_NOTES_CREATE: 'release-notes:create',
  RELEASE_NOTES_UPDATE: 'release-notes:update',
  RELEASE_NOTES_DELETE: 'release-notes:delete',

  DOWNLOAD_APPLET_READ: 'download-applet:read',
  DOWNLOAD_APPLET_CREATE: 'download-applet:create',
  DOWNLOAD_APPLET_UPDATE: 'download-applet:update',
  DOWNLOAD_APPLET_DELETE: 'download-applet:delete',

  MANAGE_ACCOUNTS_READ: 'manage-accounts:read',
  MANAGE_ACCOUNTS_CREATE: 'manage-accounts:create',
  MANAGE_ACCOUNTS_UPDATE: 'manage-accounts:update',
  MANAGE_ACCOUNTS_DELETE: 'manage-accounts:delete',

  FAILING_FACTORS_REPORT_READ: 'failing-factors-report:read',
  FAILING_FACTORS_REPORT_CREATE: 'failing-factors-report:create',
  FAILING_FACTORS_REPORT_UPDATE: 'failing-factors-report:update',
  FAILING_FACTORS_REPORT_DELETE: 'failing-factors-report:delete',

  ANALYTICS_READ: 'analytics:read',
  ANALYTICS_CREATE: 'analytics:create',
  ANALYTICS_UPDATE: 'analytics:update',
  ANALYTICS_DELETE: 'analytics:delete',

  PASSWORD_POLICY_READ: 'password-policy:read',
  PASSWORD_POLICY_CREATE: 'password-policy:create',
  PASSWORD_POLICY_UPDATE: 'password-policy:update',
  PASSWORD_POLICY_DELETE: 'password-policy:delete',

  CYBER_SECURITY_POLICY_READ: 'cyber-security-policy:read',
  CYBER_SECURITY_POLICY_CREATE: 'cyber-security-policy:create',
  CYBER_SECURITY_POLICY_UPDATE: 'cyber-security-policy:update',
  CYBER_SECURITY_POLICY_DELETE: 'cyber-security-policy:delete',

  DRIVE_LEAKAGE_READ: 'drive-leakage:read',
  DRIVE_LEAKAGE_CREATE: 'drive-leakage:create',
  DRIVE_LEAKAGE_UPDATE: 'drive-leakage:update',
  DRIVE_LEAKAGE_DELETE: 'drive-leakage:delete',

  PLUGINS_READ: 'plugins:read',
  PLUGINS_CREATE: 'plugins:create',
  PLUGINS_UPDATE: 'plugins:update',
  PLUGINS_DELETE: 'plugins:delete',

  RAD_READ: 'rad:read',
  RAD_CREATE: 'rad:create',
  RAD_UPDATE: 'rad:update',
  RAD_DELETE: 'rad:delete',

  MY_REPORTS_READ: 'my-reports:read',
  MY_REPORTS_CREATE: 'my-reports:create',
  MY_REPORTS_UPDATE: 'my-reports:update',
  MY_REPORTS_DELETE: 'my-reports:delete',

  SUPPORT_READ: 'support:read',
  SUPPORT_CREATE: 'support:create',
  SUPPORT_UPDATE: 'support:update',
  SUPPORT_DELETE: 'support:delete',

  DEVICE_SYSTEM_LOGS_READ: 'device-system-logs:read',
  DEVICE_SYSTEM_LOGS_CREATE: 'device-system-logs:create',
  DEVICE_SYSTEM_LOGS_UPDATE: 'device-system-logs:update',
  DEVICE_SYSTEM_LOGS_DELETE: 'device-system-logs:delete',

  COMPLIANCE_READ: 'compliance:read',
  COMPLIANCE_CREATE: 'compliance:create',
  COMPLIANCE_UPDATE: 'compliance:update',
  COMPLIANCE_DELETE: 'compliance:delete',

  LPL_SUPPORT_READ: 'lpl-support:read',
  LPL_SUPPORT_CREATE: 'lpl-support:create',
  LPL_SUPPORT_UPDATE: 'lpl-support:update',
  LPL_SUPPORT_DELETE: 'lpl-support:delete',

  RESTRICTED_APPLICATIONS_AND_PROCESSES_READ:
    'restricted-applications-and-processes:read',
  RESTRICTED_APPLICATIONS_AND_PROCESSES_CREATE:
    'restricted-applications-and-processes:create',
  RESTRICTED_APPLICATIONS_AND_PROCESSES_UPDATE:
    'restricted-applications-and-processes:update',
  RESTRICTED_APPLICATIONS_AND_PROCESSES_DELETE:
    'restricted-applications-and-processes:delete'
} as const);
